export default __webpack_public_path__ + "static/media/icon-report-agency.51289c94.svg";